var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-upload',{attrs:{"action":_vm.uploadUrl,"headers":{'Authorization': _vm.token},"multiple":_vm.multiple,"limit":_vm.limitImgNum,"on-success":_vm.uploadImgBtn}},[_c('div',{staticClass:"color-theme"},[_vm._v(_vm._s(_vm.warmTxt))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8d3f7b0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UploadFile.vue
// module id = null
// module chunks = 